import { useMutation, useQuery } from "@tanstack/react-query"
import api2 from "~/api2"
import { queryKeys } from "~/constants/queryKeys"
import { useCampContext } from "~/contexts/CampProvider"
import { useNotification } from "~/contexts/NotificationProvider"

const useAutomatedMessages = () => {
  const { campId } = useCampContext()
  const { showNotification } = useNotification()

  const fetchAutomatedMessages = useQuery({
    queryKey: [queryKeys.AUTOMATED_MESSAGES, campId],
    queryFn: () => apiFetchAutomatedMessages(campId),
    staleTime: 3000,
    enabled: !!campId,
  })

  const updateAutomatedMessages = useMutation({
    mutationFn: api2.AutomatedMessage.update,
    onSuccess: () => {
      showNotification({
        type: "success",
        title: "Changes successfully saved!",
      })
    },
    onError: () => {
      showNotification({
        type: "error",
        title: "Changes not successfully saved!",
      })
    },
  })

  return {
    index: fetchAutomatedMessages,
    update: updateAutomatedMessages,
  }
}

const apiFetchAutomatedMessages = async (campId: string) => {
  try {
    return await api2.AutomatedMessage.fetch(campId)
  } catch (error) {
    console.error("Error fetching Automated Messages:", error)
    throw error
  }
}

export default useAutomatedMessages
